// Deep Dive Asset Imports
// nOps Labs
import nopslabsProduction from "../Assets/DeepDives/nops-labs/nopslabs-production-line.png";
import peakoEvidence from "../Assets/DeepDives/nops-labs/peako-Evidence.png";
import videosProof from "../Assets/DeepDives/nops-labs/videos-proof.png";

// Bep Ink
import bepInkProof from "../Assets/DeepDives/bep-ink/bep-ink.png";
import bepInkAgent from "../Assets/DeepDives/bep-ink/pm-agent.png";
import bepInkScraper from "../Assets/DeepDives/bep-ink/bep-ink-ggmap-scraper.png";

// GFI
import gfiReach from "../Assets/DeepDives/gfi/gfi-duong-qua.png";
import gfiEvidence from "../Assets/DeepDives/gfi/evidence.png";
import gfiDocs from "../Assets/DeepDives/gfi/documentation.png";

// Gam3
import gam3Proof from "../Assets/DeepDives/gam3/gam3-proof.png";
import gam3Evidence from "../Assets/DeepDives/gam3/gam3-evidence.png";

// U2U
import u2uEvidence from "../Assets/DeepDives/u2u/evidence.png";
import u2uShift from "../Assets/DeepDives/u2u/shift.png";

// JustFab
import justfabApp from "../Assets/DeepDives/justfab/justfab-miniapp.png";
import justfabDocs from "../Assets/DeepDives/justfab/justfab-gitbook.png";

// X-Threads
import xThreadsVisual from "../Assets/DeepDives/x-threads/x-to-thread.png";

// Content Bot
import contentBotVisual from "../Assets/DeepDives/content-bot/content-bot.png";

// Attacker 2024
import attackerTop4 from "../Assets/DeepDives/attacker-2024/top-4.jpg";
import attackerVnstock from "../Assets/DeepDives/attacker-2024/vnstock-integrate.png";
import attackerEma from "../Assets/DeepDives/attacker-2024/ema-sma.png";
import attackerBollinger from "../Assets/DeepDives/attacker-2024/bollinger.png";
import attackerBacktest from "../Assets/DeepDives/attacker-2024/backtest-outcome.png";

// R&D Proximity
import rdData from "../Assets/DeepDives/rd-proximity/data.png";
import rdResult from "../Assets/DeepDives/rd-proximity/result.png";

// Green SM
import greenData from "../Assets/DeepDives/green-sm/data.png";
import greenCronbach from "../Assets/DeepDives/green-sm/cronbach-alpha.png";
import greenResult from "../Assets/DeepDives/green-sm/result.png";

// JustFactor
import justfactorShowcase from "../Assets/DeepDives/justfactor/showcase.png";
import justfactorModel from "../Assets/DeepDives/justfactor/justfactor-business-model.png";

export const identity = {
  basics: {
    name: "Cuong Phung Thai (Eddie)",
    nickname: "EDDIE",
    tagline: "Bridging Econometric Rigor with Agentic Automation.",
    quote: "Combines research-grade data thinking with the hands-on instinct to actually ship.",
    activities: [
      "Building AI Agents & Automation",
      "AI Video Generation & Styling",
      "Self-directed learning & inflation hedging"
    ],
    unfair_advantage: "I'm a Fintech student at UEH who focuses on improving how businesses operate using automation and practical tools. I founded 2 early-stage ventures, closed a $5,000 partnership deal independently, built a Virtual KOL persona with 1.3M+ reach sharing crypto experiences, and reduced content workflows from 5 hours to 1 hour using automation.",
    builder_mindset: {
      intro: [
        "I'm a Fintech student at UEH who focuses on improving how businesses operate using automation and practical tools.",
        "I like turning manual workflows into systems that are faster, more consistent, and easier to scale."
      ],
      achievements: [
        "Co-founded 2 early-stage Startups (nOps Labs, Bep Ink)",
        "Closed a $5,000 partnership deal independently",
        "Built a Virtual KOL persona with 1.3M+ reach sharing crypto experiences",
        "Reduced content workflow from 5 hours -> 1 hour using automation",
        "Prize A — CTD Scholars Academic Research Contest 2024",
        "Prize B — UEH Young Researcher 2025 (R&D Study)",
        "Prize C — UEH Young Researcher 2024 (Green SM Study)"
      ],
      current: "Currently, I'm scaling autonomous media production lines and agentic project management systems, specializing in bridging econometric logic with self-operating business infrastructure.",
      interests: [
        "Business Operations & Growth",
        "Automation & AI tools",
        "Fintech & data-driven decisions"
      ],
      closing: "I've joined multiple early-stage Web3 Startups (U2U Network, Boom Max, Gam3, JustFAB, ...), and I care a lot about efficiency and speed - not just analyzing problems, but building systems that actually solve them."
    },
    how_i_work: {
      intro: "I focus on improving how businesses operate by identifying inefficiencies and turning them into structured systems.",
      approach_title: "When I approach a problem, I usually:",
      approach_steps: [
        "Break it down into smaller, clear steps",
        "Identify repetitive or manual work",
        "Use automation or simple tools to reduce time and errors",
        "Focus on solutions that are practical and scalable"
      ],
      preferences_title: "I prefer building things that:",
      preferences: [
        "Save time",
        "Improve consistency",
        "Can scale without increasing workload"
      ]
    },
    typewriter_strings: [
      "Co-Founder @ nOps Labs",
      "Builder @ Bep Ink",
      "Business Ops & Automation",
      "Fintech Student @ UEH",
      "Building systems that save time"
    ],
  },
  personal: {
    university: "University of Economics Ho Chi Minh City (UEH)",
    major: "Financial Technology",
    location: "Ho Chi Minh City, Vietnam",
    languages: ["Vietnamese", "English (IELTS 6.5)"],
  },
  socials: {
    github: "https://github.com/thaicuong576",
    github_username: "thaicuong576",
    twitter: "https://x.com/0xeddiephung",
    linkedin: "https://www.linkedin.com/in/phungthaicuong"
  },
  startups: [
    {
      name: "nOps Labs",
      role: "Co-Founder / Builder",
      description: "AI video agency producing UGC videos, 2D animations, and news-format videos.",
      url: "#"
    },
    {
      name: "Bep Ink",
      role: "Founder / Builder",
      description: "FnB-specialist print brand in HCMC with custom-built PM & Operations dashboard.",
      url: "https://dashboard-sand-nine-57.vercel.app/"
    }
  ],
  specializations: [
    {
      id: "operations-automation",
      title: "Operations Automation",
      emoji: "⚙️",
      summary: "I build systems that reduce manual work and improve how business operations run.",
      what_i_do: [
        "Identify repetitive workflows in operations",
        "Design automation systems using tools like n8n and APIs",
        "Connect different tools into one streamlined process"
      ],
      example_projects: [
        "Content Bot: Reduced workflow from 5h -> 1h",
        "PM Agent: Automated task tracking and reporting",
        "AI UGC System: Scaled content production to 100+ videos/day"
      ],
      business_impact: [
        "Save time across operations",
        "Reduce manual errors",
        "Increase output without increasing headcount"
      ]
    },
    {
      id: "growth-leadgen",
      title: "Growth & Lead Generation",
      emoji: "📈",
      summary: "I build systems that help businesses find and convert high-intent customers.",
      what_i_do: [
        "Collect and structure lead data from sources like Google Maps",
        "Build scoring systems to identify high-quality leads",
        "Design outreach and content systems for growth"
      ],
      example_projects: [
        "Bep Ink Lead Engine: Geo-targeted lead discovery in HCMC",
        "Scraper System: Clustered F&B businesses into high-intent zones",
        "X Automation: Built content system for consistent growth"
      ],
      business_impact: [
        "Improve targeting accuracy",
        "Increase efficiency of outreach",
        "Support revenue growth"
      ]
    },
    {
      id: "data-decision",
      title: "Data & Decision Making",
      emoji: "🔍",
      summary: "I use data and structured thinking to support better business decisions.",
      what_i_do: [
        "Analyze data using econometrics and statistical models",
        "Translate raw data into actionable insights",
        "Apply structured thinking to market and business problems"
      ],
      example_projects: [
        "UEH Research: Econometric modeling for innovation analysis",
        "Algo Trading Model: VN30 prediction using EMA & indicators",
        "Consumer Study: 300+ sample behavior analysis"
      ],
      business_impact: [
        "Reduce guesswork in decisions",
        "Support strategy with data",
        "Improve clarity in complex problems"
      ]
    },
    {
      id: "content-systems",
      title: "Content Automation Systems",
      emoji: "🎥",
      summary: "I build systems that automate content production and help businesses scale media output.",
      what_i_do: [
        "Design automated pipelines for video and content production",
        "Integrate AI tools to generate scripts, visuals, and voice",
        "Optimize workflows for speed and consistency"
      ],
      example_projects: [
        "AI UGC System (nOps Labs): 100-200 videos/day production pipeline",
        "Content Bot: Automated research -> scripting -> publishing",
        "AI Video Engine: Combined n8n + FFmpeg + AI tools into one workflow"
      ],
      business_impact: [
        "Scale content without hiring more people",
        "Reduce production time significantly",
        "Maintain consistent output across platforms"
      ]
    }
  ],
  experience: [
    // WORK CATEGORY
    {
      id: "nops-labs",
      title: "nOps Labs - AI Video Factory",
      category: "work",
      role: "Co-Founder",
      date: "Aug 2024 - Present",
      description: "Established nOps Labs as an autonomous 'AI Video Factory,' engineering a 100% automated production line using n8n and programmatic FFmpeg assembly.",
      impact: "100-200 Videos/Day",
      imgPosition: "50% 50%",
      tech: ["n8n", "FFmpeg", "ComfyUI", "Python"],
      link: "https://github.com/thaicuong576",
      stats: "Autonomous Video Factory",
      specializations: ["operations-automation", "content-systems"],
      deepDive: {
        problem: "Fashion and cosmetic brands face a 'Content Velocity Problem.' To stay relevant, they need an overwhelming volume of high-quality UGC style videos—a production scale that is impossible to sustain manually without a massive editing headcount.",
        solution: "Established nOps Labs as an autonomous 'AI Video Factory.' I engineered a 100% automated production line using n8n for orchestration and Peako (FFmpeg core) for programmatic assembly. This system replaces 4 full-time human production steps with a single automated trigger, allowing for infinite scalability.",
        flow: [
          "Asset Orchestration: n8n logic triggers multiple third-party APIs to generate high-fidelity image and video frames tailored to brand aesthetics.",
          "Production Line (Peako): A custom-built FFmpeg-core engine (Peako) handles the 'dirty work'—automated assembly, transitions, branding overlays, and multi-track merging.",
          "Automated Delivery: Final rendered UGC videos are automatically verified and pushed to cloud delivery pipelines or social publishing APIs."
        ],
        results: [
          "Scaled content production to 100-200 videos per day per brand with zero human intervention.",
          "Achieved an 80% reduction in direct human labor costs per video.",
          "Enabled mid-sized fashion brands to compete at the same content volume as global industry leaders."
        ],
        visuals: [nopslabsProduction, peakoEvidence, videosProof]
      }
    },
    {
      id: "bep-ink",
      title: "Bep Ink - Growth Architecture",
      category: "work",
      role: "Founder & Tech Builder",
      date: "July 2024 - Present",
      description: "Engineered a three-pillar ecosystem combining a custom PM Dashboard, an Autonomous Dispatcher, and a Geo-Lead Engine for 100% operational visibility.",
      impact: "Operations Automated",
      imgPosition: "100% 40%",
      tech: ["Astro", "Supabase", "OpenClaw", "Scraping"],
      link: "https://dashboard-sand-nine-57.vercel.app/",
      stats: "Growth Architecture",
      specializations: ["operations-automation", "growth-leadgen"],
      deepDive: {
        problem: "Traditional printing services struggle to bridge the gap between high-quality core technology and the demands of digital marketing. Bep Ink faced a hurdle: managing digital identity and lead gen without a massive team.",
        solution: "Engineered the 'Bep Ink Growth Architecture'—a three-pillar ecosystem designed for 100% operational visibility and automated lead acquisition using Astro, Supabase, and OpenClaw.",
        flow: [
          "PM Dashboard (Control Center): Built with Astro and Supabase, tracking all project KPIs and operational metrics in real-time.",
          "24/7 AI Dispatcher: An OpenClaw-powered agent handling 100% of initial inquiries using a RAG layer for technical advice.",
          "Geo-Lead Engine: Automated scraping targeting Google Maps to identify and qualify local leads, feeding directly into the pipeline."
        ],
        results: [
          "Established a unified data layer (Supabase) providing 100% visibility into every business vertical.",
          "Automated top-of-funnel lead discovery, building a warm contact list for growth campaigns.",
          "Developed an 'Autonomous Operations' blueprint allowing a small team to manage enterprise-scale operations."
        ],
        visuals: [bepInkProof, bepInkAgent, bepInkScraper]
      }
    },
    {
      id: "gfi",
      title: "GFI Research - Virtual KOL",
      category: "work",
      role: "Content Strategy & Virtual KOL",
      date: "Nov 2024 - Feb 2026",
      description: "Developed an automated 'Virtual KOL' persona (Eddie) to maintain high content velocity in the hyper-fast Web3 industry.",
      impact: "1.3M+ Viral Reach",
      imgPosition: "100% 100%",
      tech: ["X-Social", "Brand Strategy", "n8n", "Web3"],
      link: "https://x.com/0xeddiephung",
      stats: "$5,000 Deal Closed",
      specializations: ["growth-leadgen", "content-systems"],
      deepDive: {
        problem: "In Web3, high-quality research is often lost in the noise. Without automation, a researcher cannot maintain the content velocity required to lead trends and capture market authority.",
        solution: "Developed a partly automated 'Virtual KOL' persona (Eddie) that scales research-backed content production without sacrificing quality, creating a 'Speed-to-Market' advantage.",
        flow: [
          "Identity & Vibe Engine: Programmatically aligned the 'Eddie' persona with strategic partners like Mantle.",
          "Content Factory: Built an automation pipeline producing 20 medium-to-high quality research posts per week.",
          "Data-Backed Outreach: Leveraged automated growth metrics to negotiate and close institutional partnerships."
        ],
        results: [
          "Achieved massive viral reach: 1.3M+ on X and 1M+ on Facebook for a single account.",
          "Successfully negotiated and closed a $5,000 partnership deal with the Mantle network.",
          "Maintained market leadership during volatility through consistent, automated output."
        ],
        visuals: [gfiReach, gfiEvidence, gfiDocs]
      }
    },
    {
      id: "gam3",
      title: "Gam3 - BD & MOU Engine",
      category: "work",
      role: "Personal Assistant to Founder / BD Team",
      date: "July 2024 - Sept 2024",
      description: "Engineered a structured 'BD & MOU Engine' combining automated lead discovery with a centralized tracking pipeline for Web3 gaming.",
      impact: "MOU Support (DWF & GSR)",
      imgPosition: "0% 0%",
      tech: ["Tokenomics", "Scraping", "MOU Negotiation", "Nodes"],
      link: "https://gam3s.gg/",
      stats: "50+ Institutional Partners",
      specializations: ["growth-leadgen"],
      deepDive: {
        problem: "Institutional outreach in Web3 gaming is often chaotic. Coordinating with 50+ partners across fragmented channels leads to 'lead decay' and slow MOU turnaround times.",
        solution: "Engineered a structured 'BD & MOU Engine' that combined automated lead discovery via custom scraping with a centralized tracking pipeline for real-time coordination.",
        flow: [
          "Automated Lead Discovery: Built a scraping engine targeting YouTube and LinkedIn to identify high-tier VCs and MMs.",
          "MOU Standardization: Developed a standardized lifecycle for negotiations, reducing legal friction.",
          "Strategic Sync: Automated tracking of partnership milestones for data-backed reporting."
        ],
        results: [
          "Successfully managed a pipeline of 50+ high-value institutional partners.",
          "Secured and streamlined MOUs with industry giants including DWF and GSR.",
          "Established a professional outreach protocol that served as a master class in BD operations."
        ],
        visuals: [gam3Proof, gam3Evidence]
      }
    },
    {
      id: "u2u",
      title: "U2U Network - Community Ops",
      category: "work",
      role: "Community Ops",
      date: "2024",
      description: "Executed high-stakes community operations and sentiment management for a Layer 1 blockchain network during volatile market events.",
      impact: "10,000+ Active Members",
      imgPosition: "50% 50%",
      tech: ["Community Ops", "Crisis Management", "Layer 1", "Telegram"],
      link: "https://u2u.xyz/",
      stats: "Sentiment Mastery",
      specializations: ["growth-leadgen"],
      deepDive: {
        problem: "Managing a Layer 1 community involves technical complexity and emotional volatility. Users need deep clarity, while rewards can trigger intense FUD if not managed precisely.",
        solution: "Executed high-stakes community operations using a rigorous shift-based protocol focused on proactive education and crisis de-escalation.",
        flow: [
          "High-Concentration Operations: Operated within a 24/7 team rotation for rapid response during volatile events.",
          "Technical Essence Support: Authored deep technical responses to complex questions to build community trust.",
          "Sentiment Cooling: Monitored and neutralized emotional triggers by providing data-backed clarity."
        ],
        results: [
          "Successfully managed and scaled the Vietnamese community to 10,000+ active members.",
          "Maintained healthy ecosystem sentiment during high-volatility events like airdrops.",
          "Established a culture of technical literacy, reducing repetitive support inquiries."
        ],
        visuals: [u2uEvidence, u2uShift]
      }
    },
    {
      id: "justfab",
      title: "JustFab - DataFi MiniApp",
      category: "work",
      role: "Founder",
      date: "2023",
      description: "Developed a DataFi + Gamification ecosystem aimed at returning data ownership to users through a Telegram MiniApp.",
      impact: "Web3 Tech Mastery",
      imgPosition: "50% 19%",
      tech: ["AI Agents", "ZK-Privacy", "AA", "Telegram MiniApp"],
      link: "https://github.com/thaicuong576",
      stats: "Data Ownership POC",
      specializations: ["growth-leadgen"],
      deepDive: {
        problem: "Users unknowingly forfeit privacy and economic value of their data to tech giants, creating a massive gap in data ownership and rewards.",
        solution: "Developed JustFAB, a DataFi + Gamification ecosystem (Telegram MiniApp) aimed at returning data ownership to users through experimental Web3 tech.",
        flow: [
          "Gamification: Engaged users through mini-games to collect high-value behavioral data signals.",
          "DataFi Infrastructure: Built logic for tokenizing user data and returning value to creators.",
          "Technical Experimentation: Integrated AI Agents, ZK-privacy, and Account Abstraction (AA)."
        ],
        results: [
          "Gained deep technical mastery in AI Agents, ZK-privacy, and Web2.5 GTM strategies.",
          "Strategic Realization: Learned that 'wow tech' alone doesn't guarantee success; user needs are priority.",
          "Founder Lesson: Prioritize the unique value of your game and users over chasing others' success."
        ],
        visuals: [justfabApp, justfabDocs]
      }
    },

    // PROJECTS CATEGORY
    {
      id: "x-threads",
      title: "X-Threads - Social Automator",
      category: "projects",
      role: "Growth Engineer",
      date: "2024",
      description: "Engineered a 'Cross-Platform Arbitrage Engine' that programmatically identifies viral X content and repurposes it for Threads.",
      impact: "15k+ Organic Impressions",
      imgPosition: "84% 0%",
      tech: ["n8n", "LLM Agents", "Social Automation", "Python"],
      link: "https://x.com/0xeddiephung",
      stats: "Viral Arbitrage Engine",
      specializations: ["growth-leadgen", "content-systems"],
      deepDive: {
        problem: "There is an 'insight arbitrage' opportunity between X and Threads, but manually refactoring viral content for a new audience is too time-consuming.",
        solution: "Engineered a 'Cross-Platform Arbitrage Engine' using AI to refactor X insights into the specific conversational tone required for Threads.",
        flow: [
          "Viral Discovery: Built a tracker to rank high-performing content from specific X niches.",
          "Vibe Repurposing: Leveraged LLM agents to refactor short-form X posts into thoughtful Threads formats.",
          "Automated Injection: Deployed an automated pipeline to inject content during peak engagement windows."
        ],
        results: [
          "Proof of Concept: Validated the model in just 2 weeks, proving the arbitrage theory.",
          "Viral Traction: Generated 10,000 – 15,000 organic impressions on a brand-new account.",
          "Efficiency: Demonstrated a 100% automated path to cross-platform visibility."
        ],
        visuals: [xThreadsVisual]
      }
    },
    {
      id: "content-bot",
      title: "Eddie Content Bot",
      category: "projects",
      role: "Automation Lead",
      date: "2024",
      description: "Personal workflow optimizer designed to clone my specific writing style, reducing production cycles from 5 hours to 1 hour.",
      impact: "80% Efficiency Gain",
      imgPosition: "0% 0%",
      tech: ["n8n", "LLMs", "RAG", "Style Injection"],
      link: "https://github.com/thaicuong576",
      stats: "5h -> 1h Workflow",
      specializations: ["operations-automation", "content-systems"],
      deepDive: {
        problem: "Producing high-quality, research-backed articles that maintained a consistent personal voice was an exhausting 5-hour manual process.",
        solution: "Developed the 'Eddie Content Bot'—a workflow optimizer that learns linguistic patterns and 'tone-of-voice' markers to clone my writing style.",
        flow: [
          "Style Ingestion: Fed the system a dataset of top-performing articles to extract sentence structures and tone.",
          "Research-to-Draft: Bot takes raw data and passes it through a style-injection layer to generate drafts.",
          "Refinement Loop: Final editor (Eddie) performs a quick 'vibe check' and polish."
        ],
        results: [
          "80% Efficiency Gain: Reduced daily content production from 5 hours down to 1 hour.",
          "Scale: Enabled more frequent, high-rigor articles without sacrificing the personal touch.",
          "Consistency: Maintained a unified voice across X, Facebook, and long-form articles."
        ],
        visuals: [contentBotVisual]
      }
    },

     {
      id: "attacker-2024",
      title: "ATTACKER 2024 - Algo Trading",
      category: "academy",
      role: "Team Leader",
      date: "April 2024",
      description: "Sophisticated trend-following algorithmic model for navigating the VN30 and Vietnamese equity markets.",
      impact: "Top 4 Finalist (UEL x Yuanta)",
      imgPosition: "52% 100%",
      tech: ["Python", "vnstock", "pandas_ta", "Plotly"],
      link: "https://github.com/thaicuong576",
      stats: "124.6% Alpha Achieved",
      specializations: ["data-decision"],
      deepDive: {
        problem: "The VN30 index is highly volatile; traders struggle with emotional bias when monitoring indicators across 30 symbols simultaneously.",
        solution: "Developed a trend-following algorithmic model using Python, vnstock, and pandas_ta to identify high-probability entry/exit points.",
        flow: [
          "Multi-Source Screening: Automated filtering of 50+ stocks based on market cap and liquidity thresholds.",
          "Hybrid Signal Logic: Engineered a dual-trigger system using EMA/SMA crossovers and Bollinger Bands.",
          "Visual Intelligence: Integrated Plotly for interactive charts to allow rapid visual verification of signals."
        ],
        results: [
          "Top 4 Finalist: Ranked in the Top 4 of the ATTACKER 2024 competition.",
          "Backtesting Alpha: Achieved 124.6% total profit on HOSE constituents during the test period.",
          "Operational Discipline: Removed human emotion from trading, delivering high-rigor risk management."
        ],
        visuals: [attackerTop4, attackerVnstock, attackerEma, attackerBollinger, attackerBacktest]
      }
    },
    {
      id: "rd-proximity",
      title: "R&D Proximity - Innovation Analysis",
      category: "academy",
      role: "Lead Researcher",
      date: "2024",
      description: "High-rigor econometric study analyzing knowledge spillover effects of High Technology Centers on firm-level innovation.",
      impact: "UEH Young Researcher 2025",
      imgPosition: "50% 50%",
      tech: ["Econometrics", "Panel Data", "STATA", "Spatial Analysis"],
      link: "https://github.com/thaicuong576",
      stats: "Prize B — UEH 2025",
      specializations: ["data-decision"],
      deepDive: {
        problem: "Lack of empirical evidence on how geographical distance to Tech Centers and national laws impact the profitability of Vietnamese firms.",
        solution: "Conducted a longitudinal econometric study spanning 14 years to analyze the interaction between R&D, proximity, and law impact.",
        flow: [
          "Dataset Construction: Aggregated and cleaned panel data from listed firms from 2009–2022.",
          "Spatial Analysis: Calculated coordinates and distance of each firm relative to major High-Tech Centers.",
          "Econometric Modeling: Applied Panel Data Regression to test R&D effectiveness and law impact."
        ],
        results: [
          "Negative Distance Correlation: Proved that distance to HTCs negatively impacts R&D ROI.",
          "Policy Insight: Demonstrated that the 2017 Law shifted firm choices toward intangible assets (IP).",
          "Award-Winning: Prize B at the 'Nhà Nghiên cứu trẻ UEH' 2025 festival."
        ],
        visuals: [rdData, rdResult]
      }
    },
    {
      id: "green-sm",
      title: "Green SM - Consumer Research",
      category: "academy",
      role: "Lead Researcher",
      date: "2024",
      description: "Quantitative study applying TPB and TAM models to decode the 'Green' consumer mindset in HCMC.",
      impact: "Excellent Research UEH 2024",
      imgPosition: "40% 72%",
      tech: ["SPSS 27.0", "EFA", "TPB/TAM", "Linear Regression"],
      link: "https://github.com/thaicuong576",
      stats: "Prize C — UEH 2024",
      specializations: ["data-decision"],
      deepDive: {
        problem: "What actually drives young demographics to switch to EV taxis? Is it environmental concern, price, or social pressure?",
        solution: "Produced an award-winning research paper using TPB and TAM models to decode the consumer mindset for Green SM in HCMC.",
        flow: [
          "Survey Architecture: Executed an online survey collecting data from 390 students across HCMC.",
          "Statistical Rigor: Used SPSS for Reliability Testing (Cronbach's Alpha) and EFA.",
          "Hypothesis Testing: Analyzed Attitude, Subjective Norms, and Environmental Concern."
        ],
        results: [
          "Key Discovery: Proved 'Environmental Concern' is the strongest driver, outweighing price for students.",
          "Actionable Strategy: Proposed a framework for GSM to enhance their 'Green' branding campaigns.",
          "Academic Excellence: Prize C at the UEH Research Festival 2024."
        ],
        visuals: [greenData, greenCronbach, greenResult]
      }
    },
    {
      id: "justfactor",
      title: "JustFactor - Fintech Credit MVP",
      category: "academy",
      role: "Project Lead",
      date: "Q1 2026",
      description: "Intelligent Origination Platform (B2B2B) transforming SME records into standardized, bank-ready credit assets.",
      impact: "90% Friction Reduction",
      imgPosition: "95% 55%",
      tech: ["FastAPI", "Supabase", "React", "Banking APIs"],
      link: "https://github.com/thaicuong576",
      stats: "$24B Credit Gap Solution",
      specializations: ["operations-automation", "data-decision"],
      deepDive: {
        problem: "Vietnamese SMEs face a $24B funding shortfall because manual underwriting costs for banks are disproportionately high.",
        solution: "Developed JustFactor, an automation layer that transforms invoices and tax records into standardized, bank-ready assets.",
        flow: [
          "Data Ingestion: SMEs connect bank accounts via Casso and upload digital invoices.",
          "J-Score Engine: Custom scoring logic in FastAPI analyzes cash flow patterns to generate audit reports.",
          "Marketplace Matching: Verified receivables are listed for Financial Institutions to execute factoring."
        ],
        results: [
          "90% Friction Reduction: Automated the first 80% of the credit due diligence process.",
          "Fintech Innovation: Successfully developed the Functional MVP using FastAPI and Supabase.",
          "Strategic Roadmap: Designed a path for invoice fractionalization and DeFi expansion.",
        ],
        visuals: [justfactorShowcase, justfactorModel]
      }
    }
  ],
  certificates: [
    {
      id: "blockchain-specialization",
      title: "Blockchain Specialization",
      issuer: "Coursera / University at Buffalo",
      date: "2024",
      description: "Comprehensive program covering blockchain foundations, smart contracts, decentralized applications (Dapps), and blockchain platforms.",
      link: "https://www.coursera.org/account/accomplishments/specialization/JN7VELD2ZFT3",
      img_key: "blockchain"
    },
    {
      id: "trading-ml-ibm",
      title: "Trading Strategies with Machine Learning",
      issuer: "Coursera / IBM",
      date: "2024",
      description: "Advanced course on applying machine learning algorithms to develop and backtest quantitative trading strategies.",
      link: "https://www.coursera.org/account/accomplishments/verify/K3JWU9C7487N",
      img_key: "trading-ml"
    },
    {
      id: "python-michigan",
      title: "Python for Everybody",
      issuer: "Coursera / University of Michigan",
      date: "2023",
      description: "Mastery of Python programming basics, data structures, web scraping, and database management.",
      link: "https://www.coursera.org/account/accomplishments/verify/FRD53C3CUAZN",
      img_key: "python-michigan"
    },
    {
      id: "ai-intro-ibm",
      title: "Introduction to Artificial Intelligence (AI)",
      issuer: "Coursera / IBM",
      date: "2023",
      description: "Foundational knowledge of AI concepts, machine learning, deep learning, and generative AI applications.",
      link: "https://www.coursera.org/account/accomplishments/verify/67VFKCK8JVR7",
      img_key: "ai-intro"
    },
    {
      id: "word-associate",
      title: "Microsoft Word Associate (Microsoft 365 Apps)",
      issuer: "Microsoft",
      date: "2024",
      description: "Professional certification in advanced document creation, collaboration, and formatting.",
      link: "/Word Associate.pdf",
      img_key: "word"
    },
    {
      id: "excel-associate",
      title: "Microsoft Excel Associate (Microsoft 365 Apps)",
      issuer: "Microsoft",
      date: "2024",
      description: "Professional certification in data management, formulas, charts, and financial analysis.",
      link: "/Excel Associate.pdf",
      img_key: "excel"
    },
    {
      id: "powerpoint-associate",
      title: "Microsoft Powerpoint Associate (Microsoft 365 Apps)",
      issuer: "Microsoft",
      date: "2024",
      description: "Professional certification in high-impact presentation design and visual communication.",
      link: "/PowerPoint Associate.pdf",
      img_key: "powerpoint"
    },
    {
      id: "mos-associate",
      title: "Microsoft Office Specialist: Associate (Microsoft 365 Apps)",
      issuer: "Microsoft",
      date: "2024",
      description: "Earned by passing three associate-level exams (Excel, Word, and Powerpoint), demonstrating comprehensive proficiency across the Microsoft 365 suite.",
      link: "/MOS Associate.pdf",
      img_key: "mos"
    }
  ],
  skills: {
    tools: [
      { name: "n8n", img_key: "n8n" },
      { name: "Python", img_key: "Python" },
      { name: "JavaScript", img_key: "Javascript" },
      { name: "Git", img_key: "Git" },
      { name: "Docker", img_key: "Docker" },
      { name: "Node.js", img_key: "nodejs" },
      { name: "Antigravity", img_key: "antigravity" },
      { name: "NocoDB", img_key: "nocodb" },
      { name: "OpenClaw", img_key: "openclaw" },
      { name: "Vercel", img_key: "Vercel" },
    ]
  }
};
